module.exports = __webpack_public_path__ + "img/center07.2ad60348.png";